import { render, staticRenderFns } from "./InsightsTab.vue?vue&type=template&id=406a420d&scoped=true"
import script from "./InsightsTab.vue?vue&type=script&lang=js"
export * from "./InsightsTab.vue?vue&type=script&lang=js"
import style0 from "./InsightsTab.vue?vue&type=style&index=0&id=406a420d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a420d",
  null
  
)

export default component.exports